var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"not-found"},[_c('div',{staticClass:"code"},[_vm._v("Nepavyko rasti šio puslapio")]),_c('div',{staticClass:"text"},[_vm._v(" Labai atsiprašome, kad nepavyko rasti puslapio, kurio ieškote ")]),_c('a',{staticClass:"button",attrs:{"href":"/"}},[_vm._v("Grįžti į pradinį puslapį")])])])
}]

export { render, staticRenderFns }